import RowTRComponentSwitch from "views/device-configuration/alerts/components/RowTRComponentSwitch";

const FormMQ24GConfigAlerts = ({item = {}, _TC}) => {
    // Console.log("item", item);
    const values = item.values || {};
    const has = item.has || {};
    const updated = item.updated || {};
    return (
        <>
            <RowTRComponentSwitch
                fieldName={"nivel_llenado_a"}
                _TC={_TC}
                valueIn={values.nivel_llenado_a}
                hasIn={has.nivel_llenado_a}
                updatedIn={updated.nivel_llenado_a}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "400",
                    step: "1",
                    "data-default": "90",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"nivel_llenado_d"}
                _TC={_TC}
                valueIn={values.nivel_llenado_d}
                hasIn={has.nivel_llenado_d}
                updatedIn={updated.nivel_llenado_d}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "400",
                    step: "1",
                    "data-default": "80",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"difllen"}
                _TC={_TC}
                valueIn={values.difllen}
                hasIn={has.difllen}
                updatedIn={updated.difllen}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "400",
                    step: "1",
                    "data-default": "40",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"difvac"}
                _TC={_TC}
                valueIn={values.difvac}
                hasIn={has.difvac}
                updatedIn={updated.difvac}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "400",
                    step: "1",
                    "data-default": "60",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"sacc"}
                _TC={_TC}
                valueIn={values.sacc}
                hasIn={has.sacc}
                updatedIn={updated.sacc}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "254",
                    step: "1",
                    "data-default": "80",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"t_volcado"}
                _TC={_TC}
                valueIn={values.t_volcado}
                hasIn={has.t_volcado}
                updatedIn={updated.t_volcado}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "1800",
                    step: "1",
                    "data-default": "240",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"t_mov_permanente"}
                _TC={_TC}
                valueIn={values.t_mov_permanente}
                hasIn={has.t_mov_permanente}
                updatedIn={updated.t_mov_permanente}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "60",
                    step: "1",
                    "data-default": "4",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"angulo_a"}
                _TC={_TC}
                valueIn={values.angulo_a}
                hasIn={has.angulo_a}
                updatedIn={updated.angulo_a}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "180",
                    step: "1",
                    "data-default": "90",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"angulo_d"}
                _TC={_TC}
                valueIn={values.angulo_d}
                hasIn={has.angulo_d}
                updatedIn={updated.angulo_d}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "80",
                    step: "1",
                    "data-default": "80",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"alta_temp_a"}
                _TC={_TC}
                valueIn={values.alta_temp_a}
                hasIn={has.alta_temp_a}
                updatedIn={updated.alta_temp_a}
                deactivated="0"
                inputProps={{
                    min: "-40",
                    max: "120",
                    step: "1",
                    "data-default": "70",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"alta_temp_d"}
                _TC={_TC}
                valueIn={values.alta_temp_d}
                hasIn={has.alta_temp_d}
                updatedIn={updated.alta_temp_d}
                deactivated="0"
                inputProps={{
                    min: "-40",
                    max: "120",
                    step: "1",
                    "data-default": "60",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"baja_temp_a"}
                _TC={_TC}
                valueIn={values.baja_temp_a}
                hasIn={has.baja_temp_d}
                updatedIn={updated.baja_temp_a}
                deactivated="0"
                inputProps={{
                    min: "-40",
                    max: "120",
                    step: "1",
                    "data-default": "6",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"baja_temp_d"}
                _TC={_TC}
                valueIn={values.baja_temp_d}
                hasIn={has.baja_temp_d}
                updatedIn={updated.baja_temp_d}
                deactivated="0"
                inputProps={{
                    min: "-40",
                    max: "120",
                    step: "1",
                    "data-default": "10",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"incendio"}
                _TC={_TC}
                valueIn={values.incendio}
                hasIn={has.incendio}
                updatedIn={updated.incendio}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "100",
                    step: "1",
                    "data-default": "80",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"bat"}
                _TC={_TC}
                valueIn={values.bat}
                hasIn={has.bat}
                updatedIn={updated.bat}
                deactivated="0"
                inputProps={{
                    min: "1",
                    max: "100",
                    step: "1",
                    "data-default": "30",
                }}
            />
            <RowTRComponentSwitch
                fieldName={"height"}
                _TC={_TC}
                valueIn={values.height}
                hasIn={has.height}
                updatedIn={updated.height}
                deactivated="0"
                noInput
            />
        </>
    );
};
export default FormMQ24GConfigAlerts;
